import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AllAppointmentsData } from 'src/app/_models/all-appointments.model';

@Component({
  selector: 'app-add-proplem-modal',
  templateUrl: './add-proplem-modal.component.html',
  styleUrls: ['./add-proplem-modal.component.scss']
})
export class AddProplemModalComponent implements OnInit {
  item: AllAppointmentsData;
  addProplemForm: FormGroup;
  isSubmited: boolean = false;

  public event: EventEmitter<any> = new EventEmitter();

  constructor(
    public bsModalRef: BsModalRef,
    private _formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.addProplemForm = this._formBuilder.group({
      proplemDescription: ['', [Validators.required]],
    });
  }

  onAddProplemSubmit() {
    this.event.emit(this.addProplemForm.value.proplemDescription);
  }
}

